import useMutationCall from "../../../hooks/useMutationCall";
import { useAddInvoiceMutation } from "../projectsSlice";

const useAddInvoice = () => {
  return useMutationCall(useAddInvoiceMutation);
};

export default useAddInvoice;
